import brands from './brands';
import brandUnit from './brand-unit';
import cpfSearched from './cpfSearched';
import payments from './payments';
import currentAdmission from './admission/currentAdmission';
import global from './global';
import healthInsurance from './healthInsurance';
import mdm from './mdm';
import modal from './modal';
import questionnaire from './questionnaire';
import searchExams from './searchExams';
import validation from './validation';
import registrationData from './registrationData';
import medicalOrders from './medicalOrders';
import professionalIdentification from './professionalIdentification';

export const modules = {
  brands,
  brandUnit,
  cpfSearched,
  payments,
  currentAdmission,
  global,
  healthInsurance,
  mdm,
  medicalOrders,
  modal,
  professionalIdentification,
  questionnaire,
  searchExams,
  validation,
  registrationData,
};
